import { TokenAction } from "../models/token.action";
import BaseService from "./_base.service";

const endpoint = "token/actions";

const TokenActionService = {
  ...BaseService<TokenAction>({ endpoint }),
};

export default TokenActionService;
